<template>
  <button class="ask-widget-button" v-bind:class="{ adjustLeft: settings.button_position == 'left'}" v-bind:style="{ background: settings.button_background, color: settings.button_font, top: settings.button_top + '%' }">
    {{ settings.name }}
  </button>
</template>

<script>
import { loadSettings } from '../services/loadSettings'

export default {
  name: 'WidgetButton',
  mixins: [loadSettings],
  data () {
    return {
      ask: {},
      settings: {}
    }
  },
  methods: {
  },
  mounted () {
    this.ask = this.$ask
    this.loadSettings()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/WidgetButton.vue